module.exports = __webpack_public_path__ + "static/media/example-dark.37e4bca9.svg";